<button *ngFor="let kasse of selectKassen" (click)="prov(kasse)">{{kasse.bezeichnung}}</button>